import { Assignment, AssignementDetails, AssignmentDisplayData } from 'types/assignment';
import { CondominiumInfo, CondominiumImplant } from 'types/condominium';
import { AssignmentActivity } from 'types/activity';
import { TabsItem } from '@fattureincloud/fic-design-system';
import { TabNames } from './constants';
import { ForwardDetails } from 'types/forwardAction';

export const getAssignmentDetails = (assignment: Assignment): AssignementDetails => {
  const { interventoID, dataCreazione, attivitaPriorita, token, stato, dataPrevista } = assignment;
  const {
    fornitoreNome,
    fornitoreEmail,
    amministratoreNome,
    attivitaOperatore,
    attivitaReferente,
    attivitaReferenteContatto
  } = assignment;
  const { motivazioneChiusura, motivazioneUltimoCambioData } = assignment;
  const { ultimoAggiornamento, nuoviMessaggi, dataEsecuzione } = assignment;
  return {
    interventoID,
    dataCreazione,
    attivitaPriorita,
    amministratoreNome,
    attivitaReferente,
    attivitaReferenteContatto,
    token,
    stato,
    dataPrevista,
    fornitoreNome,
    fornitoreEmail,
    attivitaOperatore,
    motivazioneChiusura,
    motivazioneUltimoCambioData,
    ultimoAggiornamento,
    nuoviMessaggi,
    dataEsecuzione
  };
};

export const getCondominiumDetails = (assignment: Assignment): CondominiumInfo => {
  const {
    condominioNome,
    condominioVia,
    condominioCAP,
    condominioCitta,
    condominioProv,
    condominioCF,
    SDI
  } = assignment;
  return { condominioNome, condominioVia, condominioCAP, condominioCitta, condominioProv, condominioCF, SDI };
};

export const getCondominiumImplant = (assignment: Assignment): CondominiumImplant => {
  const { impiantoDescrizione, impiantoUbicazione } = assignment;
  return { impiantoDescrizione, impiantoUbicazione };
};

export const getActivityDetails = (assignment: Assignment): AssignmentActivity => {
  const {
    attivitaInterventoID,
    attivitaNr,
    attivitaTitolo,
    attivitaDescrizione,
    attivitaOperatore,
    attivitaReferente,
    attivitaReferenteContatto,
    noteIntervento
  } = assignment;
  return {
    attivitaInterventoID,
    attivitaNr,
    attivitaTitolo,
    attivitaDescrizione,
    attivitaOperatore,
    attivitaReferente,
    attivitaReferenteContatto,
    noteIntervento
  };
};

export const getForwardData = (assignment: Assignment): ForwardDetails => {
  const { dataInoltro, emailDa } = assignment;
  return { dataInoltro, emailDa };
};

export const getAssignmentDisplayData = (assignment: Assignment): AssignmentDisplayData => {
  const details = getAssignmentDetails(assignment);
  const condominium = getCondominiumDetails(assignment);
  const condominumImplant = getCondominiumImplant(assignment);
  const activity = getActivityDetails(assignment);
  const forward = getForwardData(assignment);
  return { details, condominium, condominumImplant, activity, pid: assignment.pid, forward };
};

export const getMobileTabs = (
  currentTab: TabNames,
  change: React.Dispatch<React.SetStateAction<TabNames>>,
  addForwardTab: boolean
) => {
  const tabs: TabsItem[] = [];
  for (const tab in TabNames) {
    if (!addForwardTab && tab === TabNames.Inoltro) {
      break;
    }
    if (isNaN(Number(tab))) {
      tabs.push({ text: tab, active: currentTab === tab, handleClick: () => change(tab as TabNames) });
    }
  }
  return tabs;
};
